import { ICommit } from "@/apps/merchant3/shared-models/ICommit";

const actions = {
  setConfigurations: ({ commit }: ICommit, payload: string[] | null): void => {
    commit("SET_CONFIGURATIONS", payload);
  },
};

export default actions;
